export enum RedactionVersionType {
  system = "system",
}
